import { http } from '@/util/http';

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ClientFeedbackInfoResponse {
  feedbackInfo?: ClientFeedbackResponse;
  /** 反馈处理回复信息 */
  processInfos?: ClientFeedbackProcessResponse[] | null;
}

export interface ClientFeedbackInfoResponseApiResult {
  message?: string | null;
  server?: string | null;
  code?: string | null;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  time?: string;
  data?: ClientFeedbackInfoResponse;
}

export interface ClientFeedbackProblemBehaviorRequest {
  /**
   * Id
   * @format int64
   */
  problemId?: number;
  /** userId */
  openId?: string | null;
  /**
   * 1点赞 2点踩
   * @format int32
   */
  behaviorType?: number;
  /**
   * 是否有效：1：有效，2：无效（取消点赞/踩）
   * @format int32
   */
  active?: number;
}

export interface ClientFeedbackProblemResponse {
  /**
   * Id
   * @format int64
   */
  id?: number;
  /** 常见问题名称 */
  name?: string | null;
  /**
   * 排序，从小到大排序
   * @format int32
   */
  sorted?: number;
  /** 问题详情 */
  content?: string | null;
  /**
   * 行为类型，1：点赞，2：点踩
   * @format int32
   */
  behaviorType?: number | null;
}

export interface ClientFeedbackProblemResponseApiResult {
  message?: string | null;
  server?: string | null;
  code?: string | null;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  time?: string;
  data?: ClientFeedbackProblemResponse;
}

export interface ClientFeedbackProblemResponseListApiResult {
  message?: string | null;
  server?: string | null;
  code?: string | null;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  time?: string;
  data?: ClientFeedbackProblemResponse[] | null;
}

export interface ClientFeedbackProcessMarkRequest {
  /** @format int64 */
  id?: number;
  /** 用户ID */
  openId?: string | null;
  /**
   * 标记：1：已解决 2：未解决, 0: 关闭弹窗
   * @format int32
   */
  mark?: number;
  /**
   * 联系类型，1：手机号，2：微信，3：QQ，4：邮箱
   * @format int32
   */
  contactType?: number | null;
  /** 联系方式 */
  contact?: string | null;
}

export interface ClientFeedbackProcessResponse {
  /**
   * 商户：MERCHANT_RESPONSE
   * 用户：USER_REPLY
   */
  operateType?: string | null;
  /** 操作时间 */
  operateDateStr?: string | null;
  /**
   * 操作时间
   * @format date-time
   */
  operateDate?: string;
  /** 反馈内容 */
  content?: string | null;
  /** 图片，多个以逗号隔开 */
  url?: string | null;
}

export interface ClientFeedbackRequest {
  /** 应用ID */
  appId?: string | null;
  /** 用户加密ID */
  openId?: string | null;
  /** 用户名称(昵称) */
  userName?: string | null;
  /** 应用版本 */
  appVersion?: string | null;
  /** 操作系统 */
  os?: string | null;
  /** 操作系统版本 */
  osVersion?: string | null;
  /** 网络类型 */
  netType?: string | null;
  /** Ua */
  ua?: string | null;
  /** 手机型号 */
  phoneModel?: string | null;
  /**
   * 反馈类型ID
   * @format int64
   */
  feedbackTypeId?: number | null;
  /** 反馈内容 */
  content?: string | null;
  /** 反馈图片，多个以逗号隔开 */
  url?: string | null;
  /**
   * 联系类型，1：手机号，2：微信，3：QQ，4：邮箱  5: LINE
   * @format int32
   */
  contactType?: number | null;
  /** 联系方式 */
  contact?: string | null;
  /** 自定义参数 */
  extend?: string | null;
  /** 语言 */
  language?: string | null;
  /** 地区 */
  region?: string | null;
}

export interface ClientFeedbackResponse {
  /** @format int64 */
  id?: number;
  /** 反馈内容 */
  content?: string | null;
  /** 反馈图片，多个以逗号隔开 */
  url?: string | null;
  /** 联系方式 */
  contact?: string | null;
  /** 添加时间 */
  addTime?: string | null;
  /**
   * 是否查看 0:未查看 1:已查看
   * 为空表明未回复
   * @format int32
   */
  lookStatus?: number | null;
  /** 反馈类型名称 */
  problemTypeName?: string | null;
  /**
   * 是否点击过"反馈是否得到解决"
   * 1：已点击（点击叉掉也算点击） 非1或空及均未点击
   * @format int32
   */
  isClick?: number | null;
  /**
   * 处理状态 0:未处理 1:处理完成 2:处理中
   * @format int32
   */
  processStatus?: number;
  /** 处理状态 */
  processStatusName?: string | null;
}

export interface ClientFeedbackResponseListApiResult {
  message?: string | null;
  server?: string | null;
  code?: string | null;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  time?: string;
  data?: ClientFeedbackResponse[] | null;
}

export interface ClientFeedbackSearchRequest {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  lastId?: number | null;
  /** 应用ID */
  appId?: string | null;
  /** 用户加密ID */
  openId?: string | null;
  /**
   * 用户反馈ID
   * @format int64
   */
  id?: number | null;
  /** 语言，为空查询当前应用的默认语言 */
  language?: string | null;
}

export interface ClientFeedbackTypeResponse {
  /**
   * 反馈类型ID
   * @format int64
   */
  id?: number;
  /** 反馈类型名称 */
  name?: string | null;
}

export interface ClientFeedbackTypeResponseListApiResult {
  message?: string | null;
  server?: string | null;
  code?: string | null;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  time?: string;
  data?: ClientFeedbackTypeResponse[] | null;
}

/** 客户端获取广告Request */
export interface ClientGetAdsRequest {
  /** 应用Id */
  appId?: string | null;
  /** 版本号 */
  version?: string | null;
  /** 品牌 */
  brand?: string | null;
  /**
   * 时间戳
   * @format int64
   */
  timestamp?: number | null;
}

export interface ClientReplyFeedbackRequest {
  /**
   * 用户反馈问题Id
   * @format int64
   */
  id?: number;
  /** 应用ID */
  appId?: string | null;
  /** 用户加密ID */
  openId?: string | null;
  /** 用户名称(昵称) */
  userName?: string | null;
  /** 反馈内容 */
  content?: string | null;
  /** 反馈图片，多个以逗号隔开 */
  url?: string | null;
}

export interface JsonNode {
  options?: JsonNodeOptions;
  parent?: JsonNode;
  root?: JsonNode;
}

export interface JsonNodeOptions {
  propertyNameCaseInsensitive?: boolean;
}

export interface ObjectApiResult {
  message?: string | null;
  server?: string | null;
  code?: string | null;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  time?: string;
  data?: any;
}

/** 请求参数 */
export interface ShushuRequest {
  /**
   * 请求ID/AccessKey
   * @format int64
   */
  accessKey?: number;
  /**
   * 秒级时间戳1分钟内有效
   * @format int64
   */
  timestamp?: number;
  /** 数数KEY（json字符串） */
  shushuKey?: string | null;
  /** 签名$"{AccessKey}{SecretKey}{Timestamp}{ShushuKey}"32位不区分大小写MD5 */
  sign?: string | null;
  /**
   * 回调地址
   * 配置后，将不再等待请求，而是请求结束后回调该地址将结果告知
   */
  callbackUrl?: string | null;
}

/** 返回参数 */
export interface ShushuResponse {
  /**
   * 0成功，非0失败
   * @format int32
   */
  code?: number;
  /** 错误描述 */
  msg?: string | null;
  /** 数数结果 */
  result?: any;
}

export interface UploadUrlResponse {
  uploadUrl?: string | null;
  cname?: string | null;
}

export interface UploadUrlResponseApiResult {
  message?: string | null;
  server?: string | null;
  code?: string | null;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  time?: string;
  data?: UploadUrlResponse;
}

type GetApiResult<T> = T extends { data?: infer R } ? R : T;

/**
 * @title IOIO.AD.WebApi
 * @version 1.0
 */

/**
 * No description
 *
 * @tags File
 * @name FileSignurlCreate
 * @summary 图片文件上传，签名url获取
 * @request POST:/api/file/signurl
 */
export const postApiFileSignurl = (
  data: {
    /**
     * 文件流
     * @format binary
     */
    file?: File;
  },
  query?: {
    /** 保存文件目录 */
    name?: string;
    /** 文件名 */
    fileName?: string;
  },
) => {
  return http.post<GetApiResult<UploadUrlResponseApiResult>>(`/api/file/signurl`, query);
};
/**
 * No description
 *
 * @tags Program
 * @name AdGetadsCreate
 * @request POST:/api/ad/getads
 */
export const postApiAdGetads = (data: ClientGetAdsRequest) => {
  return http.post<GetApiResult<void>>(`/api/ad/getads`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name V2AdGetadsCreate
 * @request POST:/api/v2/ad/getads
 */
export const postApiV2AdGetads = (data: ClientGetAdsRequest) => {
  return http.post<GetApiResult<void>>(`/api/v2/ad/getads`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name V3AdGetadsCreate
 * @request POST:/api/v3/ad/getads
 */
export const postApiV3AdGetads = (data: ClientGetAdsRequest) => {
  return http.post<GetApiResult<void>>(`/api/v3/ad/getads`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackBannerList
 * @summary 获取应用用户反馈banner信息
 * @request GET:/api/feedback/banner
 */
export const getApiFeedbackBanner = (query: {
  appId: string;
  /** 语种code */
  language?: string;
}) => {
  return http.get<GetApiResult<ObjectApiResult>>(`/api/feedback/banner`, query);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackAddCreate
 * @summary 用户反馈添加
 * @request POST:/api/feedback/add
 */
export const postApiFeedbackAdd = (data: ClientFeedbackRequest) => {
  return http.post<GetApiResult<ObjectApiResult>>(`/api/feedback/add`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackReplyCreate
 * @summary 用户追加回复
 * @request POST:/api/feedback/reply
 */
export const postApiFeedbackReply = (data: ClientReplyFeedbackRequest) => {
  return http.post<GetApiResult<ObjectApiResult>>(`/api/feedback/reply`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackTypeList
 * @summary 应用反馈类型列表
 * @request GET:/api/feedback/type
 */
export const getApiFeedbackType = (query: {
  appId: string;
  openId?: string;
  /** 语种 */
  language?: string;
}) => {
  return http.get<GetApiResult<ClientFeedbackTypeResponseListApiResult>>(`/api/feedback/type`, query);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackListCreate
 * @summary 用户反馈列表
 * @request POST:/api/feedback/list
 */
export const postApiFeedbackList = (data: ClientFeedbackSearchRequest) => {
  return http.post<GetApiResult<ClientFeedbackResponseListApiResult>>(`/api/feedback/list`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackInfoCreate
 * @summary 用户反馈详情
 * @request POST:/api/feedback/info
 */
export const postApiFeedbackInfo = (data: ClientFeedbackSearchRequest) => {
  return http.post<GetApiResult<ClientFeedbackInfoResponseApiResult>>(`/api/feedback/info`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackMarkCreate
 * @summary 用户对反馈回复的标记
 * @request POST:/api/feedback/mark
 */
export const postApiFeedbackMark = (data: ClientFeedbackProcessMarkRequest) => {
  return http.post<GetApiResult<ObjectApiResult>>(`/api/feedback/mark`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackProblemListCreate
 * @summary 应用常见问题列表
 * @request POST:/api/feedback/problem/list
 */
export const postApiFeedbackProblemList = (data: ClientFeedbackSearchRequest) => {
  return http.post<GetApiResult<ClientFeedbackProblemResponseListApiResult>>(`/api/feedback/problem/list`, data);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackProblemInfoList
 * @summary 应用常见问题详情
 * @request GET:/api/feedback/problem/info
 */
export const getApiFeedbackProblemInfo = (query: {
  /** @format int64 */
  problemId: number;
  /** 用户ID */
  openId?: string;
}) => {
  return http.get<GetApiResult<ClientFeedbackProblemResponseApiResult>>(`/api/feedback/problem/info`, query);
};
/**
 * No description
 *
 * @tags Program
 * @name FeedbackProblemBehaviorCreate
 * @summary 应用常见问题用户行为
点赞点踩
 * @request POST:/api/feedback/problem/behavior
 */
export const postApiFeedbackProblemBehavior = (data: ClientFeedbackProblemBehaviorRequest) => {
  return http.post<GetApiResult<ObjectApiResult>>(`/api/feedback/problem/behavior`, data);
};
/**
 * No description
 *
 * @tags Shushu
 * @name ShushuCreate
 * @summary 请求数数接口
 * @request POST:/api/shushu
 */
export const postApiShushu = (data: ShushuRequest) => {
  return http.post<GetApiResult<ShushuResponse>>(`/api/shushu`, data);
};
/**
 * No description
 *
 * @tags ShushuReport
 * @name ShushureportUserdataCreate
 * @summary 上报数数数据 - 新用户/活跃用户
参数json格式
{ "param": "新用户/活跃用户json数组的加密字符串"}
 * @request POST:/api/shushureport/userdata
 */
export const postApiShushureportUserdata = (data: Record<string, JsonNode>) => {
  return http.post<GetApiResult<void>>(`/api/shushureport/userdata`, data);
};
/**
 * No description
 *
 * @tags ShushuReport
 * @name ShushureportRetentiondataCreate
 * @summary 上报数数数据 - 留存数据
参数json格式
{ "param": "留存数据json数组的加密字符串"}
 * @request POST:/api/shushureport/retentiondata
 */
export const postApiShushureportRetentiondata = (data: Record<string, JsonNode>) => {
  return http.post<GetApiResult<void>>(`/api/shushureport/retentiondata`, data);
};
